import { createRouter, createWebHistory } from 'vue-router';
import MainView from '../views/MainView.vue';
import CustomerSupport from '../views/CustomerSupportView.vue';
import Introduction from '../views/IntroductionView.vue';
import Service from '../views/ServiceView.vue';
import Portfolio from '../views/PortfolioView.vue';

const routes = [
    {
        path: '/',
        name: 'Main',
        component: MainView
    },
    // {
    //     path: '/maindev',
    //     name: 'Main2',
    //     component: MainView
    // },

    {
        path: '/CustomerSupport',
        name: 'CustomerSupport',
        component: CustomerSupport
    },

    {
        path: '/Introduction',
        name: 'Introduction',
        component: Introduction
    },

    {
        path: '/Service',
        name: 'Service',
        component: Service
    },

    {
        path: '/Portfolio',
        name: 'Portfolio',
        component: Portfolio
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    }
});

export default router;
